<template>
    <div class="margin">
        <SubGroupDetail
            v-if="dadosSubGrupo.length > 0"
            ref="subGroup"
            :dadosSubGrupo="dadosSubGrupo"
            :templateid="templateid"
            :preRequisito="preRequisito"
            @NovaPerguntaPreRequisito="NovaPerguntaPreRequisito"
            @EditaPreRequisitoNovaPergunta="EditaPreRequisitoNovaPergunta"
            @ExcluirNovaPerguntaPreRequisito="ExcluirNovaPerguntaPreRequisito"
            @EditaPreRequisitoPergunta="EditaPreRequisitoPergunta"
            @ExcluirPerguntaPreRequisito="ExcluirPerguntaPreRequisito"
            @RemoverExclusaoPerguntaPreRequisito="RemoverExclusaoPerguntaPreRequisito">
        </SubGroupDetail>
        <div class="container_img" v-else>
            <img  class="img_notFound" :src="notFound">
            <div class="titulo_sem_registro">Nenhum registro encontrado</div>
            <div class="subtitulo_sem_registro">Adicione um novo registro para iniciar o cabeçalho</div>
            <button class="button" @click="criarPreRequisito">
                <i class="fas fa-plus"></i>ADICIONAR REGISTRO
            </button>
        </div>
    </div>
</template>

<script>
import prerequisiteTemplate from './prerequisiteTemplate'
export default prerequisiteTemplate
</script>
  <style scoped>
   .button{
    margin-top: 2rem;
    font: normal normal 600 12px / 21px Segoe UI;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 37px;
    background-color: #008144;
    color: white;
   }
   .margin {
    margin-top: 1rem;
   }
  .container_img{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }
  .img_notFound{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .subtitulo_sem_registro {
    font: normal normal normal 16px/33px Segoe UI;
    letter-spacing: -0.3px;
    color: #4F4C4D;
  }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/prerequisiteTemplate/prerequisiteTemplate.vue